export function getFiltersFromSlug(slug: string): string {
  const slugWithoutPage = slug.replace(/page-\d+\/?$/, '');
  const slugParts = slugWithoutPage.split('/').filter(Boolean);

  const filtersUrl = slugParts.join(slugParts.length > 1 ? '/' : '');

  const filters = filtersUrl ? `${filtersUrl}/` : '';

  return filters;
}
